import { useEffect } from "react";
import {
  AboutPage,
  AstraPage,
  AstraPosPage,
  CaseStudiesPage,
  ContactPage,
  HomePage,
  IndustriesPage,
  SolutionsPage,
} from "./site-pages";

function normalizePathname(pathname: string) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

const pageMeta: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Zenisoft Ghana - Built for African enterprises.",
    description:
      "Zenisoft Ghana develops ERP systems for finance, inventory, HR and operations. Powering manufacturing, agro-processing, SMEs and government.",
  },
  "/about": {
    title: "About Zenisoft - Ghana's ERP Builders",
    description:
      "Zenisoft Ghana is a software company building ERP systems for African enterprises. Learn our story, mission and values.",
  },
  "/solutions": {
    title: "ERP Solutions - Zenisoft Ghana",
    description:
      "Explore Zenisoft's ERP solutions: development, automation, manufacturing, finance and HR systems for African businesses.",
  },
  "/astra": {
    title: "Astra ERP - All-in-one ERP for African Businesses",
    description:
      "Astra ERP is Zenisoft's flagship platform: inventory, manufacturing, finance, HR and reporting in one system.",
  },
  "/astra-pos": {
    title: "Astra POS - Retail Point-of-Sale for African Stores",
    description:
      "Astra POS by Zenisoft: fast checkout, real-time inventory, multi-branch sales and offline-ready operation for retailers.",
  },
  "/industries": {
    title: "Industries - Zenisoft Ghana",
    description:
      "ERP solutions tailored for manufacturing, agro-processing, retail, finance, government and SMEs.",
  },
  "/case-studies": {
    title: "Case Studies - Zenisoft Ghana",
    description:
      "Real ERP deployments by Zenisoft, including the Agrocrown Manufacturing System.",
  },
  "/contact": {
    title: "Contact Zenisoft - Book a Demo",
    description: "Book a demo, request a quote or talk to Zenisoft Ghana about your ERP project.",
  },
};

export function App() {
  const pathname = normalizePathname(window.location.pathname);

  useEffect(() => {
    const meta = pageMeta[pathname] ?? pageMeta["/"];
    document.title = meta.title;

    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement("meta");
      description.setAttribute("name", "description");
      document.head.appendChild(description);
    }
    description.setAttribute("content", meta.description);
  }, [pathname]);

  switch (pathname) {
    case "/":
      return <HomePage />;
    case "/about":
      return <AboutPage />;
    case "/solutions":
      return <SolutionsPage />;
    case "/astra":
      return <AstraPage />;
    case "/astra-pos":
      return <AstraPosPage />;
    case "/industries":
      return <IndustriesPage />;
    case "/case-studies":
      return <CaseStudiesPage />;
    case "/contact":
      return <ContactPage />;
    default:
      return <HomePage />;
  }
}
